import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreAddNewCard as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    iframeTheme: 'cartera-pc-form',
    getTitle: (merchantName) => (merchantName ? `Add a card to link to ${merchantName}.` : 'Add a card.'),
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
